// src/components/IndustryExpertise.tsx
import Government from "../assets/Government.jpg";
import Healthcare from "../assets/Healthcare.jpg";
import Logistics from "../assets/Logistics.jpg";
import Manufacturing from "../assets/Manufacturing.jpg";
import Energy from "../assets/Energy.jpg";
import Facility from "../assets/Facilty.jpg";

export default function IndustryExpertise() {
  const industries = [
    {
      title: "Government & Public Sector",
      description:
        "Senpiper delivers analytics platforms that empower agencies with instant data insights, automated reports, and predictive tools—driving transparent governance and smarter decision-making.",
      img: Government,
    },
    {
      title: "Manufacturing & Industrial",
      description:
        "Our solutions bring real-time analytics and AI-powered tracking to operations. We optimize processes, minimize downtime, and boost production quality through actionable manufacturing data.",
      img: Manufacturing,
    },
    {
      title: "Healthcare Survey Management",
      description:
        "Senpiper's digital analytics system enabled wide-scale health surveys, providing live population data and automated analysis to support effective public health strategy and rapid response.",
      img: Healthcare,
    },
    {
      title: "Logistics & Supply Chain",
      description:
        "We enhance supply chain agility by delivering real-time tracking, proactive anomaly detection, and interactive dashboards for seamless, data-informed logistics operations.",
      img: Logistics,
    },
    {
      title: "Energy & Utilities",
      description:
        "Senpiper's analytics connect IoT data to predictive models, elevating asset performance, optimizing resource flows, and advancing sustainability for smarter energy management.",
      img: Energy,
    },
    {
      title: "Facility Management",
      description:
        "Our analytics-led platforms offer clear insights into resource allocation, security trends, and workflow performance, enabling facilities to maximize efficiency and reduce costs.",
      img: Facility,
    },
  ];

  return (
    <section className="px-4 sm:px-6 md:px-16 lg:px-28 2xl:px-40 py-16 sm:py-20 lg:py-28 bg-white flex flex-col items-center gap-12 sm:gap-16 lg:gap-20">
      {/* Header */}
      <div className="max-w-4xl text-center flex flex-col gap-4 sm:gap-6 px-4">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-zinc-700 tracking-wide font-['IBM_Plex_Sans'] leading-tight">
          Industry Expertise That Drives <br className="hidden sm:block" /> Transformative Impact
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-gray-700 font-['Nunito Sans'] leading-relaxed">
          Supporting diverse sectors with tailored AI-powered cloud, analytics,
          and security solutions to accelerate innovation, efficiency, and
          growth.
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 w-full max-w-7xl">
        {industries.map((industry, i) => (
          <div
            key={i}
            className="w-full max-w-sm mx-auto h-auto min-h-[240px] sm:min-h-[230px] lg:min-h-[320px] p-4 sm:p-6 bg-white rounded-lg outline outline-[0.8px] outline-slate-300 flex flex-col gap-3 sm:gap-4 shadow-sm hover:shadow-md transition"
          >
            {/* Image with overlay + title */}
            <div className="relative w-full h-32 sm:h-36 lg:h-[150px] overflow-hidden rounded-lg">
              <img
                src={industry.img}
                alt={industry.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/50" />
              <h3 className="absolute inset-0 flex items-center justify-center px-2 text-center text-white text-sm sm:text-base lg:text-lg font-bold leading-tight font-['Nunito Sans']">
                {industry.title}
              </h3>
            </div>

            {/* Description */}
            <p className="text-gray-700 text-xs sm:text-sm lg:text-base font-normal leading-relaxed text-center flex-1 font-['Nunito Sans']">
              {industry.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
